import { render, staticRenderFns } from "./EmptyListPlaceholder.vue?vue&type=template&id=327d431e&scoped=true&"
import script from "./EmptyListPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./EmptyListPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyListPlaceholder.vue?vue&type=style&index=0&id=327d431e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327d431e",
  null
  
)

export default component.exports